export const cardsList = {
    filterByAuthorized: true,
};
